const advantages = [
  {
    icon: 'ri-team-line',
    title: '资深专家团队',
    description: '核心团队成员平均拥有15年以上国际化业务经验，来自麦肯锡、阿里巴巴、汇丰银行等全球顶级机构。',
  },
  {
    icon: 'ri-earth-line',
    title: '全球服务网络',
    description: '覆盖全球50+国家和地区的服务网络，在新加坡、迪拜、伦敦等国际枢纽设有分支机构。',
  },
  {
    icon: 'ri-database-2-line',
    title: '数据驱动决策',
    description: '自建全球商业数据库，整合超过10万条国际市场数据，为您的国际化决策提供精准支持。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '全程风险管控',
    description: '建立完善的风险评估和管控体系，从法律合规到市场风险，为您的海外业务保驾护航。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '专属一对一服务',
    description: '每个客户配备专属项目经理，提供7x24小时全程跟进服务，确保项目高效落地。',
  },
  {
    icon: 'ri-award-line',
    title: '行业领先口碑',
    description: '累计服务超过500家企业，客户满意度高达98%，在行业内建立了卓越的品牌声誉。',
  },
];

export default function Advantages() {
  return (
    <section className="w-full px-6 md:px-10 py-16 md:py-20 bg-background-100/70">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="text-xs font-semibold tracking-widest uppercase text-primary-500 mb-3 block">为什么选择我们</span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
            征途国际的核心优势
          </h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto leading-relaxed">
            凭借深厚的行业积淀和全球资源网络，我们为您提供最专业的国际化服务
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {advantages.map((item) => (
            <div
              key={item.title}
              className="flex gap-4 p-5 bg-background-50 border border-background-200/60 rounded-lg"
            >
              <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center bg-accent-100/80 rounded-lg">
                <i className={`${item.icon} text-lg text-accent-600`}></i>
              </div>
              <div>
                <h3 className="text-sm font-semibold text-foreground-950 mb-1.5">{item.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}